import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { NotFound, DynamicLinkFallback, Success } from './components/pages';
import { EmailActivation } from './components/pages/EmailActivation';
import { Header } from './shared/header';
import { PageLayoutContainer } from './shared/Layout.styles';
import { Footer } from './shared/footer';
import ErrorBoundary from './shared/ErrorBoundary/ErrorBoundary';

const Routes = () => {
  return (
    <HashRouter>
      <Header />
      <PageLayoutContainer>
        <ErrorBoundary>
          <Switch>
            <Route exact path="/" component={EmailActivation} />
            {/* <Route exact path="/terms" component={Terms} /> */}
            <Route exact path="/success" component={Success} />
            <Route exact path="/fallback" component={DynamicLinkFallback} />
            <Route exact path="*" component={NotFound} />
          </Switch>
        </ErrorBoundary>
        <Footer />
      </PageLayoutContainer>
    </HashRouter>
  );
};

export default Routes;
